var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueueAdminLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 60,
    viewBox: "0 0 14 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.21233 48.7449C1.45793 48.497 1.58676 48.1599 1.59887 47.7337L1.599 28.9849C1.60088 28.5493 1.73766 28.1841 2.00934 27.8892L9.15417 20.5886C9.32508 20.3858 9.42012 20.1146 9.43933 19.7748L9.43882 0.317966C9.4191 -0.0428017 9.28478 -0.0965842 9.03586 0.156685L8.31712 0.891087C8.00002 1.21375 7.84129 1.61021 7.8409 2.0805V17.2174C7.81924 17.5628 7.71841 17.8482 7.53839 18.0736L2.08454 23.6553C1.73431 23.9681 1.57244 23.9101 1.59893 23.4813L1.59896 8.00744C1.58219 7.65176 1.45889 7.5858 1.22908 7.80958L0.46387 8.59153C0.160873 8.87298 0.00654507 9.23123 0.000951767 9.66629V49.358C-0.0134287 49.7738 0.135306 49.83 0.447124 49.5268L1.21233 48.7449Z",
    fill: "url(#paint0_linear_2165_1978)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53791 34.3602C4.24306 34.6352 4.09637 34.5886 4.09778 34.2205V31.352C4.10152 30.8895 4.24674 30.5083 4.53343 30.2085L9.09952 25.543C9.32655 25.3231 9.43981 25.3932 9.43933 25.7534V28.6391C9.42162 29.1544 9.25065 29.5668 8.9264 29.8761L4.53791 34.3602Z",
    fill: "url(#paint1_linear_2165_1978)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7008 11.255C12.4552 11.5029 12.3263 11.84 12.3142 12.2662L12.3141 31.015C12.3122 31.4505 12.1754 31.8158 11.9037 32.1107L4.75892 39.4113C4.588 39.614 4.49296 39.8853 4.47375 40.2251L4.47426 59.6819C4.49398 60.0427 4.6283 60.0965 4.87723 59.8432L5.59597 59.1088C5.91306 58.7861 6.0718 58.3897 6.07218 57.9194V42.7825C6.09385 42.4371 6.19468 42.1517 6.3747 41.9262L11.8285 36.3446C12.1788 36.0318 12.3406 36.0898 12.3142 36.5186L12.3141 51.9924C12.3309 52.3481 12.4542 52.4141 12.684 52.1903L13.4492 51.4084C13.7522 51.1269 13.9065 50.7687 13.9121 50.3336V10.6419C13.9265 10.2261 13.7778 10.1698 13.466 10.4731L12.7008 11.255Z",
    fill: "url(#paint2_linear_2165_1978)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2165_1978",
    x1: 4.71967,
    y1: 0,
    x2: 4.71967,
    y2: 49.7186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5896D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60C0E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2165_1978",
    x1: 6.76855,
    y1: 25.418,
    x2: 6.76855,
    y2: 34.5366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5896D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60C0E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2165_1978",
    x1: 9.19342,
    y1: 10.2812,
    x2: 9.19342,
    y2: 59.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5896D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60C0E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueAdminLogo);
export default __webpack_public_path__ + "static/media/queueAdminLogo.c25c734e71ec3340e9c92c396f4b8ff6.svg";
export { ForwardRef as ReactComponent };